// ©2024 Austin App House. All rights reserved.
import React from 'react';
import DatePicker from 'react-datepicker';
import CustomSelect from '../layout/CustomSelect';
import { dashboard as dashboardSelectStyle, dashboardSelectClassNames } from '../../utils/customSelectStyle';

const SUSPENDED_FILTER_OPTIONS = [
  { value: 'all', label: 'All contractors' },
  { value: 'active', label: 'Active only' },
  { value: 'suspended', label: 'Suspended only' },
  { value: 'deactivated', label: 'Deactivated only' },
];

const DateRangeFilter = ({
  id,
  label,
  range,
  onChange,
}) => (
  <div className="subpage-contractors-status subpage-contractors-date">
    <span className="subpage-contractors-status__label">{label}</span>
    <div className="subpage-contractors-date__range">
      <DatePicker
        id={`${id}-from`}
        selected={range.from}
        onChange={(date) => onChange({ ...range, from: date })}
        selectsStart
        startDate={range.from}
        endDate={range.to}
        maxDate={range.to || undefined}
        dateFormat="MM/dd/yyyy"
        placeholderText="From"
        isClearable
        className="dashboard-input subpage-filters__date"
      />
      <span className="subpage-contractors-date__sep">–</span>
      <DatePicker
        id={`${id}-to`}
        selected={range.to}
        onChange={(date) => onChange({ ...range, to: date })}
        selectsEnd
        startDate={range.from}
        endDate={range.to}
        minDate={range.from || undefined}
        dateFormat="MM/dd/yyyy"
        placeholderText="To"
        isClearable
        className="dashboard-input subpage-filters__date"
      />
    </div>
  </div>
);

const AdminContractorFilters = ({
  certificates = [],
  selectedCertificates,
  onCertificateChange,
  suspendedFilter,
  onSuspendedFilterChange,
  registeredDateRange,
  onRegisteredDateRangeChange,
  lastLoginRange,
  onLastLoginRangeChange,
}) => (
  <div className="subpage-contractors-filters">
    {certificates.length > 0 && (
      <div className="subpage-contractors-certificates">
        {certificates.map((certificate) => {
          const inputId = `admin-cert-${certificate._id}`;
          return (
            <label
              key={certificate._id}
              htmlFor={inputId}
              className="wo-check-btn check_btn dashboard-filter-check subpage-contractors-check"
            >
              <input
                type="checkbox"
                id={inputId}
                name={certificate.name}
                value={certificate._id}
                checked={selectedCertificates.has(certificate._id)}
                onChange={onCertificateChange}
              />
              <span>{certificate.name}</span>
            </label>
          );
        })}
      </div>
    )}

    <div className="subpage-contractors-status">
      <label className="subpage-contractors-status__label" htmlFor="admin-contractors-status">
        Account status
      </label>
      <div className="dashboard-select-wrap subpage-contractors-status__select">
        <CustomSelect
          inputId="admin-contractors-status"
          styles={dashboardSelectStyle}
          classNames={dashboardSelectClassNames}
          options={SUSPENDED_FILTER_OPTIONS}
          value={SUSPENDED_FILTER_OPTIONS.find((o) => o.value === suspendedFilter)}
          onChange={(option) => onSuspendedFilterChange(option?.value || 'all')}
          isSearchable={false}
        />
      </div>
    </div>

    <DateRangeFilter
      id="admin-contractors-registered"
      label="Registered date"
      range={registeredDateRange}
      onChange={onRegisteredDateRangeChange}
    />

    <DateRangeFilter
      id="admin-contractors-last-login"
      label="Last login"
      range={lastLoginRange}
      onChange={onLastLoginRangeChange}
    />
  </div>
);

export default AdminContractorFilters;
